import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  IconButton,
  Typography,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useNavigate } from "react-router-dom";
import apiClient from "../BaseUrl/apiClient";
import "../css/App.css";
import "../css/color.css";
import TokenService from "../service/TokenService";
import SearchTextField from "../CustomComponant/SearchTextField";
import ListDynamicTable from "../CustomComponant/ListDynamicTable";
import { DISPLAY_PAGE_SIZE } from "../constants/constants";

function SearchbyName() {
  const [returnData, setReturnData] = useState([]);
  const [totalRows, setTotalRows] = useState("");
  const [srcinddata, setSrcinddata] = useState("");

  const navigate = useNavigate();

  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = DISPLAY_PAGE_SIZE;

  const tokenServiceDetails =
    TokenService.getUserDetails();

  const uname = tokenServiceDetails?.uname;

  /* =====================================================
     SEARCH DATA
  ====================================================== */
  useEffect(() => {
    const handler = setTimeout(() => {
      const fetchData = async () => {
        try {
          const response = await apiClient.post(
            "/searchbyItem",
            {
              uname: uname,
              limit: String(
                pageSize * (currentPage - 1)
              ),
              offset: String(pageSize),
              srcinddata: srcinddata,
            }
          );

          setReturnData(response.data);

          setTotalRows(
            response.data[0]?.totaldata || 0
          );
        } catch (error) {
          setReturnData([]);
          setTotalRows(0);
        }
      };

      fetchData();
    }, 300);

    return () => {
      clearTimeout(handler);
    };
  }, [
    srcinddata,
    currentPage,
    pageSize,
    uname,
  ]);

  /* =====================================================
     ROW CLICK
  ====================================================== */
  const handleRowClick = (row) => {
    viewData(row.ponumber);
  };

  /* =====================================================
     VIEW PO
  ====================================================== */
  const viewData = (e) => {
    navigate("searchpodata", {
      state: {
        po_id: e,
      },
    });
  };

  /* =====================================================
     TABLE COLUMNS
  ====================================================== */
  const columns = [
    "indentnumber",
    "itemname",
    "indreceiptdate",
    "ConsigneeCode",
    "ponumber",
  ];

  const columnNames = [
    "Indent Number",
    "Item Name",
    "Indent Date",
    "Consignee",
    "PO Number",
  ];

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: "100%",
        minWidth: 0,
        boxSizing: "border-box",
        overflowX: "hidden",
        background: "#f5f9ff",

        p: {
          xs: 0.8,
          sm: 1.2,
          md: 1.8,
        },
      }}
    >
      {/* =====================================================
          MAIN CARD
      ====================================================== */}
      <Card
        elevation={0}
        sx={{
          width: "100%",
          maxWidth: "100%",
          minWidth: 0,
          boxSizing: "border-box",

          borderRadius: {
            xs: 2,
            sm: 2.5,
            md: 3,
          },

          overflow: "hidden",

          border:
            "1px solid #d9e4f1",

          background: "#ffffff",

          boxShadow:
            "0 6px 24px rgba(13,71,161,0.08)",
        }}
      >
        {/* ===================================================
            BLUE HEADER
        ==================================================== */}
        <Box
          sx={{
            position: "relative",

            px: {
              xs: 1.5,
              sm: 2.5,
              md: 3,
            },

            py: {
              xs: 1.5,
              sm: 2,
              md: 2.3,
            },

            color: "#ffffff",

            background:
              "linear-gradient(135deg,#0d47a1 0%,#1565c0 48%,#1976d2 100%)",

            overflow: "hidden",

            "&::after": {
              content: '""',

              position: "absolute",

              width: {
                xs: 110,
                sm: 160,
                md: 220,
              },

              height: {
                xs: 110,
                sm: 160,
                md: 220,
              },

              right: {
                xs: -50,
                sm: -65,
                md: -85,
              },

              top: {
                xs: -60,
                sm: -80,
                md: -110,
              },

              borderRadius: "50%",

              background:
                "rgba(255,255,255,0.08)",
            },
          }}
        >
          <Box
            sx={{
              position: "relative",
              zIndex: 1,

              display: "flex",
              alignItems: "center",

              gap: {
                xs: 1,
                sm: 1.4,
              },

              minWidth: 0,
            }}
          >
            {/* SEARCH ICON */}
            <Box
              sx={{
                width: {
                  xs: 42,
                  sm: 48,
                  md: 52,
                },

                height: {
                  xs: 42,
                  sm: 48,
                  md: 52,
                },

                minWidth: {
                  xs: 42,
                  sm: 48,
                  md: 52,
                },

                borderRadius: {
                  xs: 1.8,
                  sm: 2.2,
                },

                display: "flex",
                alignItems: "center",
                justifyContent: "center",

                background:
                  "rgba(255,255,255,0.16)",

                border:
                  "1px solid rgba(255,255,255,0.25)",

                backdropFilter:
                  "blur(8px)",

                boxShadow:
                  "0 4px 14px rgba(0,0,0,0.12)",
              }}
            >
              <SearchIcon
                sx={{
                  fontSize: {
                    xs: 22,
                    sm: 26,
                    md: 29,
                  },
                }}
              />
            </Box>

            {/* TITLE */}
            <Box
              sx={{
                minWidth: 0,
                flex: 1,
              }}
            >
              <Typography
                sx={{
                  fontWeight: 900,

                  fontSize: {
                    xs: "1rem",
                    sm: "1.2rem",
                    md: "1.35rem",
                  },

                  lineHeight: 1.25,

                  overflowWrap: "anywhere",
                  wordBreak: "break-word",
                }}
              >
                Search by Item Name
              </Typography>

              <Typography
                sx={{
                  mt: 0.35,

                  fontSize: {
                    xs: "0.68rem",
                    sm: "0.78rem",
                    md: "0.84rem",
                  },

                  opacity: 0.88,

                  overflowWrap: "anywhere",
                }}
              >
                Search items and view their
                associated purchase order
              </Typography>
            </Box>
          </Box>
        </Box>

        {/* ===================================================
            CONTENT
        ==================================================== */}
        <CardContent
          sx={{
            width: "100%",
            maxWidth: "100%",
            minWidth: 0,
            boxSizing: "border-box",

            p: {
              xs: 1.2,
              sm: 1.8,
              md: 2.5,
            },

            "&:last-child": {
              pb: {
                xs: 1.2,
                sm: 1.8,
                md: 2.5,
              },
            },
          }}
        >
          {/* =================================================
              SEARCH SECTION
          ================================================== */}
          {currentPage === 1 ? (
            <Box
              sx={{
                width: "100%",
                maxWidth: "100%",
                minWidth: 0,
                boxSizing: "border-box",

                mb: {
                  xs: 1.5,
                  sm: 2,
                },

                p: {
                  xs: 1,
                  sm: 1.3,
                  md: 1.5,
                },

                borderRadius: {
                  xs: 1.8,
                  sm: 2,
                },

                border:
                  "1px solid #d9e5f2",

                background:
                  "linear-gradient(135deg,#f3f8ff 0%,#ffffff 100%)",

                boxShadow:
                  "0 2px 8px rgba(13,71,161,0.04)",

                "& .MuiInputBase-root": {
                  background: "#ffffff",
                },
              }}
            >
              <SearchTextField
                label="Item Name"
                value={srcinddata}
                title="Enter Item Name"
                onChange={(e) => {
                  setSrcinddata(e.target.value);

                  // Always start a new search
                  // from the first page.
                  setCurrentPage(1);
                }}
                adornment={
                  <IconButton
                    title="Search Item"
                    size="small"
                    sx={{
                      color: "#1565c0",

                      background:
                        "linear-gradient(135deg,#e3f2fd,#bbdefb)",

                      border:
                        "1px solid rgba(21,101,192,0.15)",

                      "&:hover": {
                        background:
                          "linear-gradient(135deg,#bbdefb,#90caf9)",
                      },
                    }}
                  >
                    <SearchIcon
                      sx={{
                        fontSize: {
                          xs: 19,
                          sm: 21,
                        },
                      }}
                    />
                  </IconButton>
                }
              />
            </Box>
          ) : null}

          {/* =================================================
              RESULT TABLE
          ================================================== */}
          <Box
            sx={{
              width: "100%",
              maxWidth: "100%",
              minWidth: 0,
              boxSizing: "border-box",

              border:
                "1px solid #d9e5f2",

              borderRadius: {
                xs: 1.8,
                sm: 2,
                md: 2.5,
              },

              background: "#ffffff",

              overflow: "hidden",

              boxShadow:
                "0 2px 10px rgba(13,71,161,0.04)",

              "& *": {
                boxSizing: "border-box",
              },

              /* =================================================
                 IMPORTANT TABLE WIDTH RULES
              ================================================== */
              "& table": {
                width: "100% !important",
                maxWidth: "100% !important",
                minWidth: "0 !important",
                tableLayout:
                  "fixed !important",
              },

              "& th": {
                whiteSpace:
                  "normal !important",

                overflowWrap:
                  "anywhere !important",

                wordBreak:
                  "break-word !important",
              },

              "& td": {
                whiteSpace:
                  "normal !important",

                overflowWrap:
                  "anywhere !important",

                wordBreak:
                  "break-word !important",
              },
            }}
          >
            <ListDynamicTable
              columns={columns}
              columnNames={columnNames}
              data={returnData}
              totalRows={totalRows}
              pageSize={pageSize}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              onRowClick={handleRowClick}
            />
          </Box>

          {/* =================================================
              INFORMATION FOOTER
          ================================================== */}
          <Box
            sx={{
              mt: 1.5,

              px: 1.2,
              py: 0.8,

              borderRadius: 1.5,

              background: "#f5f9ff",

              border:
                "1px solid #e2ebf5",

              textAlign: "center",
            }}
          >
            <Typography
              sx={{
                color: "#607d8b",

                fontSize: {
                  xs: "0.68rem",
                  sm: "0.74rem",
                },

                fontWeight: 600,
              }}
            >
              Click on a record to view the
              Purchase Order details
            </Typography>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
}

export default SearchbyName;